import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "right" }
const _hoisted_2 = { class: "more" }

import ChatMenu from "@/views/Home/components/ChatMenu.vue";
import { computed, toRefs } from "vue";
import {
  showEditChatTitleDialogue,
  editForm,
} from "@/components/Dialogues/useData/useDialogues";
import { deleteDialogue } from "@/views/Home/useData/module/dialogue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatListItem',
  props: {
  sessionItem: {
    type: Object,
    required: true,
  },
  isSelected: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    required: true,
  },
},
  emits: ["changeDialogue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const { sessionItem, isSelected, index } = toRefs(props);

const dialogueAction = (_index: number) => {
  // 0 edit 1 remove
  if (_index == 0) {
    editForm.index = index?.value;
    editForm.content = sessionItem.value.title;
    console.log("edit", editForm);
    showEditChatTitleDialogue.value = true;
  } else {
    deleteDialogue(index?.value);
  }
};

const emits = __emit;

const changeDialogue = () => {
  emits("changeDialogue");
};

return (_ctx: any,_cache: any) => {
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["item-base", {
      selected: _unref(isSelected),
    }])
  }, [
    _createElementVNode("div", {
      class: "left",
      onClick: _withModifiers(changeDialogue, ["stop"])
    }, _toDisplayString(_unref(sessionItem).title), 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_popover, {
        placement: "bottom",
        width: 200,
        trigger: "click",
        "show-arrow": false
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_MoreFilled)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(ChatMenu, { onDialogueAction: dialogueAction })
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})